import { Component, OnInit } from '@angular/core';
import { DisplayModes } from '../../../models/enums';
import { BusinessUnit } from '../../../models/lookups/business-unit.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';
import { HelperMethodsService } from '../../../services/helper-methods.service';
import { ItemService } from '../../item/item.service';
import { RepresentationApiService } from '../../services/representation-api.service'; 
import { SettingService } from '../../../settings/components/settings/setting.service';
import { Setting } from '../../../settings/models/setting.model';
import { ItemsApiService } from '../../services/items-api.service';


@Component({
  selector: 'crm-save-representation-items',
  templateUrl: './save-representation-items.component.html',
  styleUrls: ['./save-representation-items.component.css']
})
export class SaveRepresentationItemsComponent implements OnInit {


  itemBrands: any[] = [];
  representationItems: any[] = [];
  representationItem: any = {};
  displayMode: DisplayModes = DisplayModes.Success;
  startDate: any;
  endDate: any;
  public changesCallback: () => void;
  visitsByItems: boolean = false;
  items: any[] = [];

  constructor(private readonly itemService: ItemService, private readonly settingService: SettingService,
    private readonly alertService: AlertService, private readonly representationService: RepresentationApiService,
    private readonly helperMethods: HelperMethodsService, private readonly itemsApiService: ItemsApiService,
    private readonly translateService: AppTranslationService) { }


  ngOnInit() {
    this.gettemBrands();
    this.getItemms();
    this.getSettings();
  }

  close() {
    this.changesCallback();
  }

  new(representationId: number, allList) {
    this.representationItem = {};
    this.representationItems = allList;
    this.startDate = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1
    };
    this.endDate = {
      year: new Date().getFullYear() + 1,
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 10
    };
    this.representationItem.representationId = representationId;
    this.representationItem.isCurrent = false;
  }

  getSettings() {

    this.settingService.getAllSettings().subscribe(response => {
      let settings = response as Setting[];
      this.visitsByItems = settings.find(x => { return x.key == "visitsByItems"; }).value == 'True';
     
    });
  }


  edit(representationItem, allList) {
    this.representationItem = representationItem;
    this.representationItems = allList;
    let sDate = new Date(this.representationItem.startDate);
    this.startDate = {
      year: sDate.getFullYear(),
      month: sDate.getMonth() + 1,
      day: sDate.getDate()
    };

    if (representationItem.itemBrandId)
      this.representationItem.itemBrand = this.itemBrands.find(x => x.id == representationItem.itemBrandId);

    if (representationItem.itemId)
      this.representationItem.item = this.items.find(x => x.id == representationItem.itemId);

    if (this.representationItem.endDate !== null) {
      this.endDate = {
        year: new Date(this.representationItem.endDate).getFullYear(),
        month: new Date(this.representationItem.endDate).getMonth() + 1,
        day: new Date(this.representationItem.endDate).getDate()
      }
    }

  }

  save(form) {
    if (!form.invalid) {
      this.displayMode = DisplayModes.Loading;
      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));

      this.representationItem.startDate = this.helperMethods.convertDateToUTC(new Date(this.startDate.year, this.startDate.month - 1, this.startDate.day + 1));


      if (this.endDate !== undefined)
        this.representationItem.endDate = this.helperMethods.convertDateToUTC(new Date(this.endDate.year, this.endDate.month - 1, this.endDate.day + 1));

      if (this.representationItem.itemBrand)
        this.representationItem.itemBrandId = this.representationItem.itemBrand.id;

      if (this.representationItem.item)
        this.representationItem.itemId = this.representationItem.item.id;

     
      let datesDuplicated = false;
      let orderDuplicated = false;

      if (this.representationItems) {
        datesDuplicated = this.representationItems.find(x => x.id != this.representationItem.id &&
          (
            (new Date(x.startDate) >= this.representationItem.startDate &&
              (!this.representationItem.endDate || new Date(x.startDate) <= this.representationItem.endDate))
            ||
            (this.representationItem.startDate >= new Date(x.startDate) &&
              (!x.endDate || this.representationItem.startDate <= new Date(x.endDate)))
          )
        );
        orderDuplicated = this.representationItems.find(x => x.id != this.representationItem.id &&
          x.order == this.representationItem.order);
      }
      if (datesDuplicated || orderDuplicated) {
        this.alertService.stopLoadingMessage();
        if (datesDuplicated)
          this.alertService.showStickyMessage("There is another brand in the same period", null, MessageSeverity.Error);
        else
          this.alertService.showStickyMessage("There is another brand with the same order", null, MessageSeverity.Error);
        this.displayMode = DisplayModes.Success;
        return;
      }

      this.representationService.saveRepresentationItem(this.representationItem).subscribe(response => {
        this.displayMode = DisplayModes.Success;
        this.alertService.stopLoadingMessage();
        this.alertService.showMessage("", this.translateService.getTranslation("SavedSuccessfully"), MessageSeverity.Success);
        this.changesCallback();
      }, (error) => {
        this.displayMode = DisplayModes.Error;
        this.alertService.showMessage("", this.translateService.getTranslation("FialedToSave"), MessageSeverity.Error);
        this.alertService.showStickyMessage(error, null, MessageSeverity.Error);
        this.changesCallback();
      });
    }
  }

  gettemBrands() {
    this.itemService.getAllItemBrandss().subscribe(response => {
      this.itemBrands = response as any[];
    }, error => { });
  }


  getItemms() {
    this.itemsApiService.getAllItemsMini().subscribe(response => {
      this.items = response as any[];
    }, error => { });
  }

}
